import { render } from "./DocumentsIcon.vue?vue&type=template&id=3f29f69a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/DocumentsIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f29f69a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f29f69a', __exports__)) {
    api.reload('3f29f69a', __exports__)
  }
  
  module.hot.accept("./DocumentsIcon.vue?vue&type=template&id=3f29f69a", () => {
    api.rerender('3f29f69a', render)
  })

}


export default __exports__